export default __webpack_public_path__ + "static/media/music_note_1.c5301eb5.gif";